import { executeApiCall } from 'services/api';
import { getLoaders } from 'entities/hooks/load';
import { SampleProjectStatusData, TaskSampleId } from '../types';

export const sampleLoaders = getLoaders({
  getSampleProjectsStatuses: {
    load: async ({
      projectId,
      taskId,
    }: {
      projectId: string;
      taskId: string;
    }): Promise<SampleProjectStatusData[]> => {
      return executeApiCall({
        path: `/projects/${projectId}/${taskId}/sample-statuses`,

        method: 'get',
      });
    },
  },

  findBySampleId: {
    load: async ({ sampleId }: { sampleId: string }): Promise<{ id: string | null }> => {
      return executeApiCall({
        path: `/projects/find-by-sample-id`,

        method: 'get',

        payload: {
          id: sampleId,
        },
      });
    },
  },

  taskLegacySampleIds: {
    load: async ({
      projectId,
      taskId,
    }: {
      projectId: string;
      taskId: string;
    }): Promise<TaskSampleId[]> => {
      return executeApiCall({
        path: `/projects/${projectId}/${taskId}/sample-ids`,

        method: 'get',
      });
    },
  },
});
